<template>
    <la-cartesian autoresize :height="150" :bound="[0]" :data="histo">
        <la-bar prop="value"></la-bar>
        <!--                            <la-x-axis prop="name"></la-x-axis>-->
        <!--                            <la-y-axis></la-y-axis>-->
        <la-tooltip>
            <div
                v-if="histo[props.index] && histo[props.index].value"
                class="tooltip"
                slot-scope="props"
            >
                <div class="title">
                    {{ histo[props.index].name }}
                    {{ name }}
                </div>
                <div class="subtitle">{{ histo[props.index].value }} songs</div>
            </div>
        </la-tooltip>
    </la-cartesian>
</template>

<script>
export default {
    name: "Histogram",
    props: ["values", "name", "unit"],
    computed: {
        histo() {
            // If we are using percentages, use 10 bins with 10% jumps
            let min, max, step;
            if (this.unit === "%") {
                min = 0;
                max = 1;
                step = 0.1;
            } else {
                // Otherwise, take the min and max values and generate the step size from them
                min = Math.min(...this.values);
                max = Math.max(...this.values);

                step = (max - min) / 10;
            }

            // Go through all the values, and count how many fit in each bin
            let bins = [];
            for (let i = min; i < max; i += step) {
                if (this.unit === "%") {
                    // Convert decimal to percentage and round
                    bins.push({
                        name: `${Math.round(i * 100)}-${Math.round(
                            (i + step) * 100
                        )}%`,
                        value: this.values.filter(x => x >= i && x < i + step)
                            .length
                    });
                } else {
                    // Just round and add the unit
                    bins.push({
                        name: `${Math.round(i)} - ${Math.round(i + step)} ${
                            this.unit
                        }`,
                        value: this.values.filter(x => x >= i && x < i + step)
                            .length
                    });
                }
            }
            return bins;
        }
    }
};
</script>

<style scoped lang="scss">
.tooltip {
    user-select: none;
    background-color: black;
    padding: 3px;

    .title {
        font-size: 1em;
    }
}
</style>
